import { useState } from "react";
import CustomButton from "shared/components/common/customButton";
import AllBlogs from "../../../shared/components/dashboard/blogsTable";
import styles from "./style.module.scss";
import classNames from "classnames";
import CreateBlogModal from "shared/modal/createBlogModal";
import UpdateBlogModal from "shared/modal/updateBlogModal";
import { BlogsData } from "shared/components/dashboard/blogsTable";

const DashboardBlogs = () => {
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState<BlogsData | null>(null);
  const [refreshBlogs, setRefreshBlogs] = useState(false);

  const handleCreateSuccess = () => {
    setRefreshBlogs((prev) => !prev);
  };

  const handleUpdate = (blog: BlogsData) => {
    setSelectedBlog(blog);
    setUpdateModalOpen(true);
  };

  const handleUpdateSuccess = () => {
    setRefreshBlogs((prev) => !prev);
    setSelectedBlog(null);
  };

  const handleCloseUpdateModal = () => {
    setUpdateModalOpen(false);
    setSelectedBlog(null);
  };

  return (
    <div className={classNames(styles.sectionContainer)}>
      <div className={classNames(styles.header)}>
        <div className="ms-auto w-fit">
          <CustomButton
            onClick={() => setCreateModalOpen(true)}
            title="Create a Blog"
          />
        </div>
        <div className="mt-4">
          <AllBlogs
            refresh={refreshBlogs}
            setRefreshBlogs={setRefreshBlogs}
            uploadedFile={null}
            handleUpdate={handleUpdate}
          />
        </div>
      </div>

      <CreateBlogModal
        show={createModalOpen}
        handleClose={() => setCreateModalOpen(false)}
        onSuccess={handleCreateSuccess}
      />

      <UpdateBlogModal
        show={updateModalOpen}
        handleClose={handleCloseUpdateModal}
        blog={selectedBlog}
        onSuccess={handleUpdateSuccess}
      />
    </div>
  );
};

export default DashboardBlogs;
